var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin && _vm.totalTestators > 0)?_c('v-btn',{attrs:{"loading":_vm.csvDownloading,"depressed":""},on:{"click":function($event){_vm.csvDownloading = true}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icons.mdiDownload))]),_vm._v("\n  Download csv\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }